import { Pipe, PipeTransform } from '@angular/core';

import { PersonalInfo } from '../../core/models/personal-info.interface';

@Pipe({
  name: 'fullname',
  standalone: false,
})
export class FullnamePipe implements PipeTransform {
  transform(value: PersonalInfo, ...args: unknown[]): string {
    if (value) {
      if (value.lastnamePrefix && value.lastnamePrefix.length > 0) {
        return `${value.initials} ${value.lastnamePrefix} ${value.lastname}`;
      } else {
        return `${value.initials} ${value.lastname}`;
      }
    }
    return null;
  }
}
